<template>
  <v-sheet color="primary800" class="px-4 py-3 mb-6 primary200--text bdrd-2">
    <v-form v-model="valid" @submit.prevent="onSave">
      <v-row>
        <v-col cols="12">
          <label
            v-t="'page.account.settings.self_lock.label'"
            class="primary100--text d-block font-weight-bold"
          />
          <p v-t="'page.account.settings.self_lock.description'" class="text-body-2 mb-3" />

          <v-row>
            <v-col md="6" cols="12">
              <v-select
                v-model="form.type"
                :items="types"
                filled dense flat
                class="rounded-0"
                color="primary300"
                background-color="primary900"
                :label="$t('page.account.settings.self_lock.ban_type')"
                required
                :rules="[v => !!v || $t('form_validation.required')]"
              />
            </v-col>

            <v-col md="6" cols="12">
              <v-text-field
                v-model="form.duration"
                type="text"
                filled dense flat
                class="rounded-0"
                :rules="durationRules"
                hint="5mins, 2.5 hrs, 3 hours, 6 days, etc.."
                persistent-hint
                color="primary300"
                background-color="primary900"
                :label="$t('page.account.settings.self_lock.ban_duration')"
                required
              />
            </v-col>


            <v-col cols="12" class="pt-0">
              <v-checkbox
                v-model="form.agree"
                hide-details
                required
                :rules="[v => !!v || $t('form_validation.required')]"
                color="primary200"
                class="mt-0 font-weight-semibold"
                :label="$t('page.account.settings.self_lock.checkbox')"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary600 primary100--text"
                class="rounded-0" :ripple="false"
                :disabled="!valid"
                depressed block large @click="onBan()"
              >
                <span v-if="!banDate" v-t="'page.account.settings.self_lock.invalid_duration'" />
                <span v-else>
                  <span v-t="'page.account.settings.self_lock.ban'" />
                  {{ banDate | toDateFormat('YYYY-MM-DD HH:mm:ss') }}
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import ms from 'ms'

const WEEK = 7 * 24 * 60 * 60e3

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      form: {
        type: 'bet',
        duration: '1 day',
        agree: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
    types() {
      return ['bet', 'full']
    },
    durationRules() {
      const convert = v => (v ? ms(v) : undefined)

      return [
        v => !!v || this.$t('form_validation.required'),
        v => convert(v) !== undefined || this.$t('form_validation.invalid'),
        v => (typeof convert(v) === 'number') || this.$t('form_validation.not_just_number'),
        v => convert(v) >= 0 || this.$t('form_validation.positive_num'),
        v => convert(v) >= 60 * 60e3 || 'Must be at least an hour', // TODO localize
        v => convert(v) <= WEEK || this.$t('page.account.settings.self_lock.form_validation.week'),
      ]
    },
    banDate() {
      if (!this.form.duration) return false

      const date = new Date(Date.now() + ms(this.form.duration))

      if (Number.isNaN(date.getTime())) return false

      return date
    },
  },
  methods: {
    onBan({ type, duration } = this.form) {
      if (!this.valid) return

      this.$emit('submit', { type, duration: ms(duration) })
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .settings-btn {
    .v-input__append-outer {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
